import {
  Box,
  Button,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Country } from "country-state-city";
import { getTimezonesForCountry } from 'countries-and-timezones';
import { validateProfileData } from "./validation";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    textTransform: "none",
  },
  content: {
    flexGrow: 1,
  },
  btnPrimary: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
}));

export default function Profile({
  setInviteDrawer,
  setShowComponent,
  profileData,
  setProfileData,
  departmentDetails,
}) {

  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [isLocationEditable, setIsLocationEditable] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);

  // Store ISO code mapping so you can pass it to getTimezonesForCountry
  // const countryCodeMap = Country.getAllCountries().reduce((map, country) => {
  //   map[country.name] = country.isoCode;
  //   return map;
  // }, {});

  // const fetchAllCountries = () => {
  //   const countries = Country.getAllCountries();
  //   return countries.map((country) => (
  //     <MenuItem key={country.isoCode} value={country.name}>
  //       {country.name}
  //     </MenuItem>
  //   ));
  // };

  // const allCountries = Country.getAllCountries(); // once at top-level
  // const countryCodeMap = allCountries.reduce((acc, country) => {
  //   acc[country.name] = country.isoCode;
  //   return acc;
  // }, {});

  const allCountries = Country.getAllCountries();

  const countryCodeMap = allCountries.reduce((acc, country) => {
    acc[country.name] = country.isoCode;
    return acc;
  }, {});

  const fetchAllCountries = () => {
    return allCountries.map((country) => (
      <MenuItem key={country.isoCode} value={country.name}>
        {country.name}
      </MenuItem>
    ));
  };

  const getRoleOptions = () => {
    let options = [];
    if (
      localStorage?.roleName === "Admin" &&
      (localStorage?.departmentId === "null" ||
      Number(localStorage?.getItem("departmentId")) === 1 )
    ) {
      departmentDetails.forEach((department) => {
        department.rolesList.forEach((role) => {
          options.push({
            displayName: `${department.departmentName} - ${role.role_name}`,
            departmentID: department.departmentID,
            collaborator_role_id: role.collaborator_role_id,
            collaboratorRoleName: role.role_name,
            collaborator_type_id: role.collaborator_type_id,
          });
        });
      });
    } else {
      let localDepartmentId = Number(localStorage?.departmentId);
      departmentDetails.forEach((department) => {
        if (department.departmentID === localDepartmentId) {
          department.rolesList.forEach((role) => {
            options.push({
              displayName: `${department.departmentName} - ${role.role_name}`,
              departmentID: department.departmentID,
              collaborator_role_id: role.collaborator_role_id,
              collaboratorRoleName: role.role_name,
              collaborator_type_id: role.collaborator_type_id,
            });
          });
        }
      });
    }
    return options;
  };
  const roleOptions = getRoleOptions();

  const handleRoleChange = (event) => {
    const selectedOption = roleOptions.find(
      (option) => option.displayName === event.target.value
    );

    setProfileData((prev) => ({
      ...prev,
      role: event.target.value,
      departmentID: selectedOption?.departmentID || null,
      collaborator_role_id: selectedOption?.collaborator_role_id || null,
      collaboratorRoleName: selectedOption?.collaboratorRoleName || null,
      collaborator_type_id: selectedOption?.collaborator_type_id || null,
    }));
  };

  // const handleChange = (e) => {
  //   setProfileData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      const isoCode = countryCodeMap[value];
      const timezonesObj = getTimezonesForCountry(isoCode);

      const timezones = timezonesObj
        ? Object.values(timezonesObj).map((tz) => tz.name)
        : [];

      setLocationOptions(timezones);
      setIsLocationEditable(timezones.length > 1);

      setProfileData((prev) => ({
        ...prev,
        country: value,
        location: timezones.length === 1 ? timezones[0] : "",
      }));
    } else {
      setProfileData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'country') {
  //     const isoCode = countryCodeMap[value];
  //     const timezones = getTimezonesForCountry(isoCode);
  //     const hasMultipleTimezones = timezones && Object.keys(timezones).length > 1;

  //     setIsLocationEditable(hasMultipleTimezones);

  //     // Optional: clear previous location if disabled
  //     setProfileData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //       location: hasMultipleTimezones ? prev.location : "", // clear location if disabled
  //     }));
  //   } else {
  //     setProfileData((prev) => ({ ...prev, [name]: value }));
  //   }
  // };

  const handlePhoneChange = (phone) => {
    setProfileData((prev) => ({ ...prev, phoneCode: phone }));
  };

  // Restore profile data from session storage when component mounts
  useEffect(() => {
    const savedProfileState = sessionStorage.getItem('profileState');
    if (savedProfileState) {
      try {
        const parsedState = JSON.parse(savedProfileState);
        // Merge with existing profileData to ensure we don't lose any fields
        setProfileData(prevData => ({
          ...prevData,
          ...parsedState
        }));
        
        // If country is set, also set up location options
        if (parsedState.country) {
          const isoCode = countryCodeMap[parsedState.country];
          if (isoCode) {
            const timezonesObj = getTimezonesForCountry(isoCode);
            const timezones = timezonesObj
              ? Object.values(timezonesObj).map((tz) => tz.name)
              : [];
            
            setLocationOptions(timezones);
            setIsLocationEditable(timezones.length > 1);
          }
        }
      } catch (e) {
        console.error("Error restoring Profile state:", e);
      }
    }
  }, []);

  const handleSubmit = () => {
    const validationErrors = validateProfileData(profileData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    // Store profile data in session storage before navigating
    sessionStorage.setItem('profileState', JSON.stringify(profileData));
    
    setErrors({});
    // setShowComponent("Brand");
   if(localStorage.getItem("collabType") !== "CMO"){
      setShowComponent("Brand");
    }
    else{
      setShowComponent("CDMO");
    }
  };
  return (
    <Box style={{ marginTop: "8px" }} className={classes.container}>
      <Box className={classes.content}>
        <Typography style={{ fontSize: "16px", fontWeight: 600 }} gutterBottom>
          Profile
        </Typography>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Full Name <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            placeholder="Full name"
            variant="outlined"
            size="small"
            required
            fullWidth
            value={profileData.name}
            name="name"
            //onChange={handleChange}
            onChange={(e) => {
              const regex = /^[A-Za-z\s]*$/; // ✅ Allow only alphabets and spaces
              if (regex.test(e.target.value)) {
                handleChange(e); // ✅ Update state only if input is valid
              }
            }}
            onBlur={(e) => {
              const { name, value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                const trimmedValue = value.trim();
                const syntheticEvent = {
                  target: {
                    name: name,
                    value: trimmedValue,
                  },
                };
                handleChange(syntheticEvent);
              }
            }}
            error={!!errors.name}
            helperText={errors.name}
          ></TextField>
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Email <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            name="email"
            value={profileData.email}
            placeholder="Email"
            //onChange={handleChange}


            onChange={(e) => {
              e.target.value = e.target.value
                // Allow valid email characters: letters, numbers, @, ., -, _, +, and other common special chars
                .replace(/[^a-zA-Z0-9@._+\-!#$%&'*\/=?^`{|}~]/g, "") // Remove invalid characters
                .replace(/(@.*)@/g, "$1") // Prevent multiple @
                .replace(/\.{2,}/g, ".") // Prevent consecutive dots
              handleChange(e);
            }}
            onBlur={(e) => {
              const { name, value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                const trimmedValue = value.trim();
                const syntheticEvent = {
                  target: {
                    name: name,
                    value: trimmedValue,
                  },
                };
                handleChange(syntheticEvent);
              }
            }}
            variant="outlined"
            size="small"
            required
            fullWidth
            error={!!errors.email}
            helperText={errors.email}
          ></TextField>
        </Box>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Phone
          </Typography>
          <Box style={{ display: "flex", gap: "10px" }}>
            <PhoneInput
              country={""}
              value={profileData.phoneCode}
              onChange={handlePhoneChange}
              enableSearch={true}
              inputStyle={{ width: "100%", minHeight: "40px" }}
              style={{
                flex: "0 0 30%",
                height: "40px",
              }}
              placeholder="Code"
              inputProps={{
                readOnly: true,
              }}
            />

            <TextField
              name="phoneNumber"
              placeholder="Phone number"
              value={profileData.phoneNumber}
              //onChange={handleChange}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // ✅ Remove non-numeric characters
                if (value.length <= 10) {  // ✅ Prevent input beyond 10 digits
                  setProfileData((prev) => ({ ...prev, phoneNumber: value }));
                }
              }}
              variant="outlined"
              size="small"
              required
              style={{ flexGrow: 1 }}
              error={!!errors.phone}
              helperText={errors.phone}
            ></TextField>
          </Box>
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Country of Residence <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            name="country"
            onChange={handleChange}
            select
            variant="outlined"
            fullWidth
            required
            size="small"
            error={!!errors.country}
            helperText={errors.country}
            value={profileData.country}
            SelectProps={{
              displayEmpty: true,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          >
            {" "}
            <MenuItem value="">Select Country</MenuItem>
            {fetchAllCountries()}
          </TextField>
        </Box>

        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Location (for time zone purpose)
          </Typography>
          <TextField
            name="location"
            onChange={handleChange}
            select
            required
            fullWidth
            variant="outlined"
            size="small"
            error={!!errors.location}
            helperText={errors.location}
            value={profileData.location}
            disabled={!isLocationEditable} // disabled if single
          >
            {locationOptions.length === 0 ? (
              <MenuItem value="">No Timezones</MenuItem>
            ) : (
              locationOptions.map((tz, index) => (
                <MenuItem key={index} value={tz}>
                  {tz}
                </MenuItem>
              ))
            )}
          </TextField>

        </Box>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Employee Number
          </Typography>
          <TextField
            name="employeeNumber"
            value={profileData.employeeNumber}
            //onChange={handleChange}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "employeeNumber",
                  value: e.target.value.replace(/[^a-zA-Z0-9]/g, ""), // **Allows only letters and numbers, removes special characters**
                },
              })
            }
            variant="outlined"
            size="small"
            required
            fullWidth
            error={!!errors.employeeNumber}
            helperText={errors.employeeNumber}
            placeholder="Employee number"
          ></TextField>
        </Box>
        <Box className={classes.textFieldWrapper}>
          <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
            Department - Role <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            name="role"
            onChange={handleRoleChange}
            select
            variant="outlined"
            required
            fullWidth
            size="small"
            value={profileData.role || ""}
            error={!!errors.role}
            helperText={errors.role}
            SelectProps={{
              displayEmpty: true,
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          >
            {" "}
            <MenuItem value="">Select Department - Role</MenuItem>
            {roleOptions.map((option) => (
              <MenuItem key={option.displayName} value={option.displayName}>
                {option.displayName}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          disableElevation
          onClick={() => {setInviteDrawer(false);
            sessionStorage.clear();
          }}
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>

        <Button
          className={classes.btnPrimary}
          variant="contained"
          size="small"
          //   color="primary"
          style={{ textTransform: "none" }}
          onClick={handleSubmit}
        >
         {localStorage.getItem("collabType") !== "CMO" ? "Continue and associate brands" : "Continue and Add Login Security"}
          {/* Continue and add Permissions */}
        </Button>
      </Box>
    </Box>
  );
}
